module.exports = __webpack_public_path__ + "static/media/442JamesPBrawleyDrNW_2018-06-12_167.62d2dfc6.jpg";